import type { JSX } from '@builder.io/qwik';
import { component$, useSignal } from '@builder.io/qwik';
import ShareKyivIcon from '~/icons/shareKyiv';
import ArticleShare from '~/components/Layout/Body/Article/ArticleShare/ArticleShare';
import { cva } from 'class-variance-authority';

const socialClass = cva('share-menu', {
  variants: {
    active: {
      true: '',
      false: 'hidden',
    },
  },
});

const iconClass = cva(
  'transition-all duration-300 absolute top-0 w-full h-full fill-white',
  {
    variants: {
      active: {
        true: 'opacity-0 -top-full',
        false: 'opacity-100',
      },
    },
  }
);

const xButtonClass = cva(
  'transition-all duration-300 absolute bottom-0 h-[1px] bg-white',
  {
    variants: {
      active: {
        true: 'opacity-100 w-[130%]',
        false: 'opacity-0 w-full',
      },
      which: {
        left: 'origin-bottom-left left-0',
        right: 'origin-bottom-right right-0',
      },
    },
    compoundVariants: [
      {
        active: true,
        which: 'left',
        class: '-rotate-45',
      },
      {
        active: true,
        which: 'right',
        class: 'rotate-45',
      },
    ],
  }
);

export default component$((): JSX.Element => {
  const active = useSignal(false);

  return (
    <div class='relative'>
      <button
        class='w-5 h-5 md:w-8 md:h-8'
        aria-label='share'
        onClick$={() => {
          active.value = !active.value;
        }}
      >
        <ShareKyivIcon cssClasses={iconClass({ active: active.value })} />
        <div class='w-5 md:w-8 h-5 md:h-8 absolute top-0'>
          <div class={xButtonClass({ active: active.value, which: 'left' })} />
          <div class={xButtonClass({ active: active.value, which: 'right' })} />
        </div>
      </button>
      <div
        class={socialClass({
          active: active.value,
        })}
      >
        <ArticleShare
          orientation='dropup'
          iconVariant='solid'
          background='none'
          device='all'
        />
      </div>
    </div>
  );
});
